import React, { useEffect, useState } from 'react';
// import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useFormik } from 'formik';
import axios from 'axios';
import * as Yup from 'yup';
import TextField from '@material-ui/core/TextField';
// import Button from '@material-ui/core/Button';
// import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Multiselect } from 'multiselect-react-dropdown';
import ButtonComp from '../../components/button';
import './servicestyles.css';
import { CommonConfig } from '../../config/common-config';
import token from '../../config/token';
import LoaderPopUp from '../../components/loaderpopup/loader';
import SuccessPopUp from '../../components/loaderpopup/success';
import ErrorPopUp from '../../components/loaderpopup/error';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    bottomLine: {
        borderBottom: '1px solid #ccc !important',
    },
    margn: {
        marginTop: '0px !important',
    },
});

export default function Services(props) {
    const tokens = token();
    const classes = useStyles();
    const [selectedDate, handleDateChange] = useState(null);
    const [allServicesTypes, setAllServicesTypes] = useState([]);
    const [selectedImc, setselectedImc] = useState('');
    const [selectedImcCoreName, setSelectedImcCoreName] = useState('');
    // const [selectedImcCoreName1, setSelectedImcCoreName1] = useState('');
    const [selectedType, setselectedType] = useState('');
    const [selectedChooseClientID, setSelectedChooseClientID] = useState('');
    const [clientName, setclientName] = useState('');
    const [statusID, setStatusID] = useState('');
    const [rows, setCreateService] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    // const [updateStat, setUpdateStat] = useState(false);
    const [errormsg, setErrormsg] = useState('');
    // const vertical = 'top';
    // const horizontal = 'center';
    const [totalIndidualClient, setTotalIndidualClient] = useState([]);
    const [totalCorporateClient, setTotalCorporateClient] = useState([]);
    const [isDisableAddFile, setIsDisableAddFile] = useState(true);
    const [catchErrorDiv, setCatchErrorDiv] = useState('none');
    const [coreTeam, setCoreTeam] = useState([]);
    const username = JSON.parse(sessionStorage.getItem('user'));
    const { userName } = username.result.data;
    // const [openBox, setOpenBox] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    // const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    // const usertype = userDetails.result && userDetails.result.data.userType;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    // const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    // const userToken = tempToken && tempToken.data.token;
    // const bearerToken = `Bearer ${userToken}`;
    const dbname = tennantDetails.tennantName;
    //console.log(dbname);
    // const dbname = 'Advith';
    // const [assignee, setAssignee] = useState('Assignee of Core Team member');
    const [assigneeArr, setAssigneeArr] = useState([]);
    //console.log("userDetails", userDetails);
    //console.log("dbname", dbname);
    //console.log("usertype", usertype);
    const [auditScope, setauditScope] = useState('');
    const [auditScopeSelected, setauditScopeSelected] = useState('');
    const servicesTypes = ['ITR', 'APC', 'AUDIT'];
    const [empDetails, setEmpDetails] = useState('');
    let tempArr = [];

    const getDate = (e) => {
        ////console.log(e.target.value, 'Get Date');
        handleDateChange(e.target.value);
        formik.values.year = e.target.value;
    };
    const setImc = (e) => {
        setselectedImc(e.target.value);
        // alert(e.target.value);

        //console.log("setImc", e.target.value);
    };

    const setCoreTeamNames = (e) => {
        setSelectedImcCoreName(e.id);
        //console.log('setCoreTeamNames', e.target.value);
    };
    // const setCoreTeamNames1 = (e) => {
    //     setSelectedImcCoreName1(e.target.value);
    //     //console.log('setCoreTeamNames1', e.target.value);
    // };

    const setType = (e) => {
        setselectedType(e.target.value);
        setIsDisableAddFile(false);
        setclientName('');
        //console.log("setType", e.target.value);
    };

    // const setChooseClients = (e) => {
    //     setSelectedChooseClients(e.target.value);
    //     //console.log("selectedChooseClients", e.target.value);
    // };

    const setChooseClientsID = (e) => {
        if (e !== undefined && e !== null && e !== '') {
            //console.log(e);
            const cliIdData = e.split('-');
            setSelectedChooseClientID(cliIdData[0]);
            setclientName(cliIdData[1]);
        }

        //console.log("selectedChooseClientID", e.target.value);
    };

    //console.log("setselectedImc(e.target.value)", selectedImc);
    //console.log("setSelectedImcCoreName(e.target.value)", selectedImcCoreName);

    //console.log("setselectedType(e.target.value)", selectedType);
    //console.log("setSelectedChooseClients(e.target.value)", selectedChooseClients);
    //console.log("setSelectedChooseClients(e.target.value)", selectedChooseClientID);

    //console.log("allServicesTypes", allServicesTypes);
    //console.log("statusID", statusID);
    const handleClose = () => {
        //console.log("Onclose Interval")
        setShowLoader(false);
    };

    const formik = useFormik({
        initialValues: {
            ultimateclient: '',
            ultimateClientId: '',
            firstAssignee: '',
            secondAssignee: '',
            services: '',
            year: '',
            startdate: '',
            tentativedate: '',
            description: '',
            params: '',
            // scopeOfAudit: '',
        },
        validationSchema: Yup.object().shape({
            ultimateclient: Yup.string().ensure().required('Required Field'),
            // ultimateClientId: Yup.string().required('Required'),
            services: Yup.string().required('Required'),
            // scopeOfAudit: Yup.string().required('Required'),
            // scopeOfAudit: Yup.string()
            //     .nullable()
            //     .when('services', {
            //         is: '3',
            //         then: Yup.string().required('Required Field'),
            //         otherwise: Yup.string().notRequired(),
            //     }),
            // firstAssignee: Yup.string().required('Required'),
            // secondAssignee: Yup.string().required('Required'),
            startdate: Yup.date()
                .min(new Date(Date.now() - 86400000), 'Cannot be in the past')
                .max(new Date(Date.now()), 'cannot be in the future')
                .required('Required'),
            tentativedate: Yup.date().min(Yup.ref('startdate'), "Tentative date can't be before start date").required('Required '),
            description: Yup.string().required('Required '),
            year: Yup.string().required('Required '),
        }),
        onSubmit: (values) => {
            // console.log('datavalues......', assigneeArr);

            setShowLoader(true);
            const data = {
                clientType: selectedType,
                servicetypeId: {
                    servicetypeId: Number(selectedImc),
                    servicetypeText: servicesTypes[Number(selectedImc) - 1],
                },
                clientId: Number(selectedChooseClientID),
                clientName: clientName,
                serviceYear: values.year,
                startDate: values.startdate,
                tentativeClosedate: values.tentativedate,
                description: values.description,
                assignees: assigneeArr,
                // secondAssignee: selectedImcCoreName1,
                statusId: {
                    statusId: 1,
                    servicetypeText: 'inprogress',
                },
                createdBy: userName,
                modified_by: userName,
                // scopeOfAudit: auditScope,
            };

            // console.log('data', data);

            // const interval =setTimeout(()=>{
            //     handleClose();
            // },10000);
            if (clientName === undefined || clientName === null || clientName === '') {
                handleClose();
                setCatchErrorDiv('block');
                setErrormsg('please select client');
            } else if (clientName !== undefined && clientName !== null && clientName !== '' && clientName.length > 0) {
                setCatchErrorDiv('none');
                axios
                    .post(
                        `${CommonConfig.dev.baseUrl}/api/auth/createservice-employee/${dbname}`,
                        // selectedImc == 3 ? { ...data, auditScope: auditScopeSelected } : data,
                        data,
                        tokens
                    )
                    .then((response) => {
                        if (response.status === 200) {
                            console.log('CreateCrop', response);
                            setShowLoader(false);
                            setSuccessPop(true);
                            setTimeout(() => {
                                props.history.push('/menu/openservice');
                            }, 3000);
                        }
                    })
                    .catch((error) => {
                        if (error) {
                            handleClose();
                            // const err = error.response.data;
                            // setErrormsg(err.message);
                            // setShowLoader(false);
                            // setCatchErrorDiv('block');
                            const errResult = error.response;
                            if (errResult && errResult.data) {
                                setShowLoader(false);
                                setErrorPop(true);
                                setTimeout(() => {
                                    setErrorPop(false);
                                }, 5000);
                                setErrorMsgGenerateRecceipt(errResult.data.message);
                            }
                        }
                    });
            }
        },
    });

    const getauditScopes = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl7030}/api/audit/scopes`, tokens)
            .then((response) => {
                //console.log('response', response.data);
                setauditScope(response.data);
            })
            .catch((error) => {
                //console.log(error.message);
            });
    };

    const auditScopesOptions = () => {
        const OptionList = auditScope && auditScope.map((data) => <option value={data.id}>{data.scopeofAudit}</option>);
        return OptionList;
    };
    const fetchauditscope = (e) => {
        setauditScopeSelected(auditScope[Number(e.target.value) - 1]);
    };

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/get-cs-servicetype/${dbname}`, tokens)
            .then((response) => {
                setAllServicesTypes(response.data);
            })
            .catch((error) => {
                //console.log(error);
            });
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/ultimate_corp_client/${dbname}?page=0&size=1000&sort=corpclientId,desc`, tokens)
            .then((response) => {
                setTotalCorporateClient(response.data.content);
                //console.log(response.data.content);
            })
            .catch((error) => {
                //console.log(error);
            });

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s_uclient_Ind/${dbname}?page=0&size=1000&sort=userId,desc`, tokens)
            .then((response) => {
                ////console.log('BBBBBBB',response.data.content);
                setTotalIndidualClient(response.data.content);
            });
        axios.get(`${CommonConfig.dev.baseUrl}/api/auth/get-cs-status/${dbname}`, tokens).then((response) => {
            setStatusID(response.data);
            //console.log(response.data.content);
        });
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/intClient-employee/${dbname}?page=0&size=1000&sort=empId,desc`, tokens)
            .then((response) => {
                // console.log("response", response.data.content);
                setCoreTeam(response.data.content);
                response.data.content.map((ele, i) => {
                    if (ele.officeEmail === tennantDetails.userName) {
                        setEmpDetails(ele);
                        let tempObj = {
                            id: ele.empId,
                            emailId: ele.officeEmail,
                            name: ele.firstName + ' ' + ele.lastName,
                            phoneNumber: ele.mobileNumber,
                        };
                        assigneeArr.push(tempObj);
                    }
                });
            });
        getauditScopes();
    }, [tokens]);

    const onSelect = (selectedList, selectedItem) => {
        const assignees = coreTeam.filter(function (item) {
            return item.empId === selectedItem.id;
        });
        const aArr = {
            id: assignees[0].empId,
            emailId: assignees[0].officeEmail,
            name: assignees[0].firstName + ' ' + assignees[0].lastName,
            phoneNumber: assignees[0].mobileNumber,
        };
        assigneeArr.unshift(aArr);
        setCoreTeamNames(selectedItem);
    };

    const onRemove = (selectedList, removedItem) => {
        assigneeArr.filter(function (item, index) {
            if (item.id === removedItem.id) {
                return assigneeArr.splice(index, 1);
            }
        });
        setAssigneeArr([...assigneeArr]);
    };
    const allServicesTypeOptions = (servicestype) => {
        const tempServiceType = [];
        servicestype.filter((ele) => {
            if (ele.description === 'ITR') {
                tempServiceType.push(ele);
            }
        });
        //console.log("servicestype", servicestype);
        const OptionList = tempServiceType.map((data) => <option value={data.servicetypeId}> {data.servicetypeText}</option>);
        return OptionList;
    };

    const allCoreTeamMultiOptions = (allcoreteam) => {
        const tempEmployee = allcoreteam;
        allcoreteam = [];
        tempEmployee.map((ele, i) => {
            if (ele.officeEmail != tennantDetails.userName) {
                allcoreteam.push(ele);
            }
        });
        const OptionList = allcoreteam.map((data) => ({ name: `${data.empId} - ${data.firstName} ${data.lastName}`, id: data.empId }));
        return OptionList;
    };

    const returnClients = (clientArr) => {
        console.log('ARRRRRR', clientArr);
        const OptionList = clientArr.map((data) => {
            return data.firstName
                ? `${data.iclientId} - ${data.firstName} ${data.lastName}`
                : `${data.corpclientId} - ${data.corpClientName}`;
        });
        return OptionList;
    };

    const getFinancialYearList = () => {
        //console.log('dropdownIndex,travelOutSide',dropdownIndex,travelOutSide)
        //console.log(dropdownIndex);
        const CurentYear = new Date().getFullYear();
        const minYear = CurentYear - 2;
        const maxYear = CurentYear + 200;
        const options = [];
        for (let i = minYear; i <= maxYear; i++) {
            const optioValues = `${i}-${(i + 1).toString().substr(-2)}`;
            options.push(
                <option value={optioValues}>
                    {i}-{(i + 1).toString().substr(-2)}
                </option>
            );
        }
        return options;
    };

    return (
        <>
            {/* <Snackbar
                className="deleteError"
                open={updateStat}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={() => {
                    setUpdateStat(false);
                }}
            >
                {/* <Alert
                    onClose={() => {
                        setUpdateStat(false);
                    }}
                >
                    <Card className="client-card success-color">
                        <CardContent className="client-heading">
                            <Typography variant="h5">Success</Typography>
                            <Typography variant="span">Service created successfully</Typography>
                        </CardContent>
                    </Card>
                    {/* Service created successfully */}
            {/* </Alert> */}
            {/* </Snackbar> */}

            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Service created successfully" />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}

            <form className="itecform" onSubmit={formik.handleSubmit}>
                <Card className="clientcard">
                    <CardContent className="client-heading">
                        <Typography variant="h5">Create Service</Typography>
                    </CardContent>
                    <CardContent>
                        <Grid container spacing={3} className="main-container">
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="ultimateclient" shrink>
                                        Type of client <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Select
                                        native
                                        className="bottom"
                                        name="ultimateclient"
                                        onChange={(e) => {
                                            setType(e);
                                            formik.handleChange(e);
                                        }}
                                        value={selectedType}
                                    >
                                        <option value="" selected disabled hidden>
                                            Type of client
                                        </option>
                                        <option value="Individual">Individual</option>
                                        <option value="Corporate">Corporate</option>
                                    </Select>
                                    {formik.touched.ultimateclient && formik.errors.ultimateclient ? (
                                        <span className="serviceformError">{formik.errors.ultimateclient}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="services" shrink>
                                        Select Client <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Autocomplete
                                        className="clientbottom"
                                        name="ultimateClientId"
                                        onChange={(event, value) => {
                                            setChooseClientsID(value);
                                            // formik.handleChange(value);
                                        }}
                                        SingleValue={selectedChooseClientID}
                                        value={clientName}
                                        disabled={isDisableAddFile}
                                        id="combo-box-demo"
                                        options={
                                            selectedType === 'Individual'
                                                ? returnClients(totalIndidualClient)
                                                : returnClients(totalCorporateClient)
                                        }
                                        style={{ width: '100%' }}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder="Select Client" style={{ borderBottom: '1px solid #ccc' }} />
                                        )}
                                    />

                                    {formik.touched.ultimateClientId && formik.errors.ultimateClientId ? (
                                        <span className="serviceformError">{formik.errors.ultimateClientId}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} className={classes.margn}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="services" shrink>
                                        Type of Service <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Select
                                        native
                                        className="bottom"
                                        name="services"
                                        onChange={(e) => {
                                            setImc(e);
                                            formik.handleChange(e);
                                        }}
                                        value={selectedImc}
                                    >
                                        <option value="">Type of Service</option>
                                        {allServicesTypeOptions(allServicesTypes)}
                                    </Select>
                                    {formik.touched.services && formik.errors.services ? (
                                        <span className="serviceformError">{formik.errors.services}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={12} sm={6} className={classes.margn}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="scopeOfAudit" shrink>
                                        Scope of Audit{(selectedImc == 3) ? <span style={{ color: "#ff0a047a" }}> *</span> : null}
                                    </InputLabel>
                                    <Select
                                        native
                                        className="bottom"
                                        name="scopeOfAudit"
                                        onChange={(e) => {
                                            fetchauditscope(e);
                                            formik.handleChange(e);
                                        }}
                                        value={formik.values.scopeOfAudit}
                                        disabled={selectedImc == 3 ? false : true}
                                    >
                                        <option value="">Select scope of audit</option>
                                        {auditScope && auditScopesOptions()}
                                    </Select>
                                    {formik.touched.scopeOfAudit && formik.errors.scopeOfAudit ? (
                                        <span className="serviceformError">{formik.errors.scopeOfAudit}</span>
                                    ) : null}
                                </FormControl>
                            </Grid> */}
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    {/* <label className="labelCls">Financial Year <span style={{ color: "#ff0a047a" }}>*</span></label> */}
                                    <InputLabel className="lbl" htmlFor="year" shrink>
                                        Financial Year <span style={{ color: '#ff0a047a' }}> *</span>
                                    </InputLabel>

                                    {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            disableToolbar
                                            autoOk
                                            variant="inline"
                                            views={['year']}
                                            placeholder="Select a Year"
                                            name="year"
                                            format="yyyy"
                                            onChange={(e) => {
                                                getDate(e);
                                                formik.setFieldValue('year', e);
                                            }}
                                            value={selectedDate}
                                            onBlur={formik.handleBlur}
                                            // renderInput={(renderProps) => <TextField {...renderProps} />}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            className={classes.bottomLine}
                                        />
                                    </MuiPickersUtilsProvider> */}

                                    <Select
                                        native
                                        name="year"
                                        className="bottom"
                                        placeholder="Select a Year"
                                        onChange={(e) => {
                                            getDate(e);
                                            formik.handleChange(e.target.value);
                                        }}
                                        value={selectedDate}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="">Please Select</option>
                                        {getFinancialYearList()}
                                        {/* <option value="2020">2020</option>
                                                                                                    <option value="2021">2021</option>
                                                                                                    <option value="2022">2022</option> */}
                                    </Select>

                                    {formik.touched.year && formik.errors.year ? (
                                        <span className="serviceformError">{formik.errors.year}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="description" shrink>
                                        Description <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Description"
                                        name="description"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.description}
                                    />
                                    {formik.touched.description && formik.errors.description ? (
                                        <span className="itec-validationError">{formik.errors.description}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="firstAssignee" shrink>
                                        Assignee of Team member <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Multiselect
                                        options={allCoreTeamMultiOptions(coreTeam)}
                                        selectedValues={formik.values.firstAssignee}
                                        onSelect={onSelect}
                                        onRemove={onRemove}
                                        displayValue="name"
                                        showCheckbox={true}
                                        closeOnSelect={false}
                                        placeholder="Select"
                                        showArrow={true}
                                    />
                                    {formik.touched.firstAssignee && formik.errors.firstAssignee ? (
                                        <span className="serviceformError">{formik.errors.firstAssignee}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                                        Start Date <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="date"
                                        className="bottom"
                                        name="startdate"
                                        placeholder="dd/mm/yyyy"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.startdate}
                                        inputProps={{ max: '9999-12-31' }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {formik.touched.startdate && formik.errors.startdate ? (
                                        <span className="serviceformError">{formik.errors.startdate}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="tentativedate" shrink>
                                        Tentative close date <span style={{ color: '#ff0a047a' }}>*</span>
                                    </InputLabel>
                                    <Input
                                        type="date"
                                        className="bottom"
                                        name="tentativedate"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.tentativedate}
                                        inputProps={{ max: '9999-12-31' }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {formik.touched.tentativedate && formik.errors.tentativedate ? (
                                        <span className="serviceformError">{formik.errors.tentativedate}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <div style={{ display: catchErrorDiv }}>
                    <div className="errorMsgRed">{errormsg}</div>
                </div>
                <div className="createintermediary-btndiv">
                    {(showLoader ? (
                        <LoaderPopUp showLoader={showLoader} handleClose={handleClose} title="Please wait while we create your service" />
                    ) : null) || <ButtonComp type="submit" className="intermediarybutn" title="Create Service" />}
                </div>
            </form>
        </>
    );
}
